module.exports = __webpack_public_path__ + "static/media/Vacation-Home.81336565.png";